import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

const MissionQuotationPage_Quotation_UpdatePrintSettings_Mutation = graphql(`
  mutation MissionQuotationPage_Quotation_UpdatePrintSettings(
    $printableId: Id!
    $printSettings: PrintSettingsInput!
  ) {
    updateQuotationPrintSettings(
      printableId: $printableId
      printSettings: $printSettings
    ) {
      _id
    }
  }
`);

export const useUpdateQuotationPrintSettingsMutation = () =>
  useGraphQLMutation(
    MissionQuotationPage_Quotation_UpdatePrintSettings_Mutation,
  );
